import React from 'react'
import {config} from 'src/config'
import {useAppSelector} from 'store'
import {getCountOfError} from 'store/secretword/selectors'
import {getTranslates} from 'store/translates/selectors'
import styles from './AttemptsCount.scss'

export const AttemptsCount = () => {
  const countOfErrors: number = useAppSelector(getCountOfError)
  const translates = useAppSelector(getTranslates)

  return (
    <div className={styles.wrap}>
      {translates.LEFT_ATTEMPTS}: {config.countGuessAttempts - countOfErrors + 1}
    </div>
  )
}
